import React from 'react'
import { Network } from '@mprolab/sdk'
import { Arbitrum, BNBChain, Base, Ethereum, Polygon } from '../components/Svg'

export const getChainIconByNetwork = (chainName: Network, width?: string, height?: string) => {
  switch (chainName) {
    case Network.BNB_CHAIN:
      return <BNBChain {...{ width, height }} />
    case Network.ETHEREUM:
      return <Ethereum {...{ width, height }} />
    case Network.POLYGON:
      return <Polygon {...{ width, height }} />
    case Network.ARBITRUM:
      return <Arbitrum {...{ width, height }} />
    case Network.BASE:
      return <Base {...{ width, height }} />
    default:
      return <></>
  }
}
